const config = {
  API_URL: 'https://test-api.getsling.com/v1/',
  APP_URL: 'https://test-app.getsling.com/',
  INTEGRATIONS_PAGE_URL: 'https://test-app.getsling.com/settings?tab=integrations',
  AUTHORIZATION_COOKIE: 'staging:authorization-token',
  LOGIN_PAGE_URL: 'https://test-login.getsling.com',
  SIGNUP_PAGE_URL: 'https://test-login.getsling.com/register',
  SHOPIFY_API_KEY: 'add6b15b1b916c8c15feb7f9e76d858e',
  TOAST_SLING_CONNECT_URL:
    'https://preprod.eng.toasttab.com/restaurants/admin/scheduling/sling/connect',
};
export default config;
